import type { Game } from '../shared/Game.js';
import { GAME_ENTRIES, type GameId, type GameSkins } from '../shared/GameIds.js';

type Loaders = { [K in GameId]: () => Promise<Game<GameSkins[K]>> };

const GAMES: Loaders = {
  balloons: () => import('./balloon/BalloonGame.js').then((m) => m.BalloonGame),
};

export function isGameId(value: string): value is GameId {
  return Object.hasOwn(GAME_ENTRIES, value);
}

export async function loadGame(id: string): Promise<Game<unknown>> {
  if (!isGameId(id)) {
    throw new Error(`Unknown game "${id}"`);
  }
  return GAMES[id]();
}
